// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewsInteractionBar-cls1___30e0fe5b602c4bb56c5{/*!*/}.NewsInteractionBar-cls2__aa7b6efbb5d695798fd6{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background:none;padding:6px 4px 6px 6px;border-radius:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "NewsInteractionBar-cls1___30e0fe5b602c4bb56c5",
	"cls2": "NewsInteractionBar-cls2__aa7b6efbb5d695798fd6 NewsInteractionBar-cls1___30e0fe5b602c4bb56c5"
};
export default ___CSS_LOADER_EXPORT___;
